/**
 * defa.views.SupportResponseCollectionView
 * A collection view for response items.
 * @version 1.2.0
 */
import EmptyView              from 'scripts/defa/basic/view-empty-view';
import SupportResponseSnippet from 'scripts/defa/support/view-support-response-snippet';
import CollectionView         from 'scripts/poppet/collection-view';

const SupportResponseCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	attributes: {
		'data-collection': 'response-collection',
	},
	
	childView: SupportResponseSnippet,
	
	emptyView: EmptyView,
	
	emptyViewOptions: {
		context: 'supportserp',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a child view triggers resize.
	 * @void
	 */
	onChildviewResize: function () {
		this.trigger( 'resize' );
	},
	
	/**
	 * Triggers when a child view triggers migrate.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewMigrate: function ( childView ) {
		this.trigger( 'migrate', childView );
	},
	
	/**
	 * Triggers when a child view triggers installed.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewInstalled: function ( childView ) {
		this.trigger( 'installed', childView );
	},
	
	/**
	 * Triggers when a child view triggers log.
	 * @param {view}   childView  The view where the event originated from.
	 * @void
	 */
	/* onChildviewLog: function( childView ) {
	 this.trigger( 'log', childView );
	 }, */
	
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default SupportResponseCollectionView;